/**
 * Join a game by code — /(app)/join/<code>.
 *
 * Opens the join screen already in its "found" state: the game, its rules and
 * its open seats, each with "Take this seat" (components/game/lobby/
 * JoinByCodeView). Reached from:
 *   https://warcarp.com/invite/<code>  →  /invite/[code] (thin redirector) → here
 *   the "Join a game" screen (/(app)/join) after Find.
 *
 * Viewers who are already seated, hold a saved seat, or whose game has
 * started are forwarded to /(app)/games/:id.
 */

import React from 'react'
import { useLocalSearchParams } from 'expo-router'
import { JoinByCodeView } from '../../../components/game/lobby/JoinByCodeView'

export default function JoinByCodeScreen() {
  const { code } = useLocalSearchParams<{ code: string }>()
  return <JoinByCodeView initialCode={Array.isArray(code) ? code[0] : code} />
}
